<template>
    <footer v-if="json" data-aos="custom-fade-in" >
        <div class="capper">
            <div class="capper-padded">

                <div class="mobile-tt">
                    <TTMotif/>
                </div>
                <div class="flx-lrc">
                    <div class="flx-l">
                        <div class="address" v-html="addressWithLink"></div>
                        <div v-if="json.footer.phone || json.footer.email" class="linkkrow">
                            <a v-if="json.footer.phone" class="zlink-underline-leftright-dark"  :href="`tel:${json.footer.phone}`" target="_blank">{{ json.footer.phone }}</a>
                            <div v-if="json.footer.phone" class="dot"></div>
                            <a v-if="json.footer.email" class="zlink-underline-leftright-dark"  :href="`mailto:${json.footer.email}`" target="_blank">{{ json.footer.email }}</a>
                        </div>
                    </div>
                    <div class="flx-c">
                        <TTMotif/>
                    </div>
                    <div class="flx-r">
                        <div class="items">
                            <Social/>
                            <div class="linkkrow" >
                                <template v-for="(item, index) in json.footer.nav" :key="index" >

                                    <router-link v-if="item.target === '_self'" class="zlink-underline-leftright-dark" :to="item.link">{{ item.label }}</router-link>
                                    <a v-else class="zlink-underline-leftright-dark" :href="item.link" :target="item.target">{{ item.label }}</a>
                                    <!-- Only display the dot if it's not the last item -->
                                    <div class="dot" v-if="index < json.footer.nav.length - 1" ></div>
                                </template>
                            </div>
                        </div>

                    </div>
                </div>
            </div>
        </div>
    </footer>
</template>
<script>
//state
//import Link from "@/components/pieces/Link";
import Social from '@/components/pieces/Social'
import TTMotif from "@/components/pieces/TTMotif";
export default {
    name: "footerComponent",
    components: {
        TTMotif,
        Social
        //Link,
    },
    data() {
        return {
            window:window,
            document:document,
            json:null,
        }
    },
    computed: {
        addressWithLink() {
            return `<a class="zlink-underline-leftright-dark" href="${this.json.footer.addressLink}" target="_blank">${this.json.footer.address}</a>`
        }
    },
    watch: {

    },
    mounted() {
        this.json = this.window.config.json.global
    },

    methods: {

    }
}
</script>